import formatName from 'I18n/utils/formatName';
import FormattedPhoneNumber from 'I18n/components/FormattedPhoneNumber';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import { UnknownRecipientText } from 'conversations-message-history/legacy-recipients/components/UnknownRecipientText';
import { HS_PHONE_NUMBER } from 'conversations-message-history/common-message-format/constants/deliveryIdentifierTypes';
import { getEmail, getFirstName, getLastName } from 'conversations-message-history/senders/operators/getters';
import { getDeliveryIdentifierType, getDeliveryIdentifierValue } from 'conversations-message-history/common-message-format/operators/deliveryIdentifierGetters';
import { getSingleDeliveryIdentifier } from 'conversations-message-history/common-message-format/operators/recipientGetters';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const FullRecipientName = ({
  recipient,
  genericRecipients,
  isLoading
}) => {
  const genericRecipient = genericRecipients && genericRecipients.size > 0 ? genericRecipients.first() : undefined;
  const deliveryIdentifier = genericRecipient && getSingleDeliveryIdentifier(genericRecipient);
  const deliveryIdentifierType = deliveryIdentifier ? getDeliveryIdentifierType(deliveryIdentifier) : undefined;
  const deliveryIdentifierValue = deliveryIdentifier ? getDeliveryIdentifierValue(deliveryIdentifier) : undefined;
  if (isLoading) {
    return /*#__PURE__*/_jsx(SkeletonText, {
      "data-test-id": "skeleton-text",
      width: 100
    });
  }
  const recipientName = recipient && formatName({
    firstName: getFirstName(recipient),
    lastName: getLastName(recipient),
    email: getEmail(recipient)
  });
  if (recipientName) return /*#__PURE__*/_jsx(_Fragment, {
    children: recipientName
  });
  if (deliveryIdentifierType === HS_PHONE_NUMBER && deliveryIdentifierValue) {
    return /*#__PURE__*/_jsx(FormattedPhoneNumber, {
      value: deliveryIdentifierValue
    });
  }
  return /*#__PURE__*/_jsx(UnknownRecipientText, {
    recipient: recipient
  });
};
FullRecipientName.displayName = 'RecipientName';
export default FullRecipientName;